/**
 *
 * @module providerException
 *
 */

import ErrorReason from './errorReason';
import ServiceException from './serviceException';

/**
 *
 * @class ProviderException
 * @extends {ServiceException}
 * @desc An unexpected error occurred with a platform provider implementation.
 *
 */
export default class ProviderException extends ServiceException {

    /**
     *
     * @param {String} message - Human-readable description of the error.
     *
     */
    constructor(message) {

        const reasons = [new ErrorReason('', message)];
        const exceptionData = {
            name: 'ProviderException',
            message
        };

        const options = { reasons, exceptionData };

        super(options);

    }

    /**
     *
     * @access public
     * @returns {String}
     *
     */
    static get typeName() {
        return 'ProviderException';
    }

    /**
     *
     * @access public
     * @desc A brief message describing the exception
     * @returns {String}
     *
     */
    static get message() {
        return 'An unexpected error occurred with a platform provider implementation.';
    }

}



// WEBPACK FOOTER //
// ./src/services/exception/providerException.js